export default __webpack_public_path__ + "static/media/internalUser.4d8ba150.png";